import { hideStr, isMobile, showStr } from "./modulesMap/Config";
import { HeroldMapRoute } from "./modulesMap/HeroldMap";
import { SearchInput } from "./modulesMap/SearchInput";

$(function () {
    if (typeof features === 'undefined') {
        var features = {};
        features.features = [];
    }
    if (typeof featuresSponsorAdvertiser === 'undefined') {
        var featuresSponsorAdvertiser = {};
        featuresSponsorAdvertiser.features = [];
    }
    if (typeof featuresForeignAdvertiser === 'undefined') {
        var featuresForeignAdvertiser = {};
        featuresForeignAdvertiser.features = [];
    }

    var $map = $("#mapGLContainer"),
        routeMap = new HeroldMapRoute()
            .setKey(mapboxGLKey)
            .setType("route")
            .setControls()
            .setZoom(0)
            .setPoiconfig(poiconfig)
            .setFeatures(features)
            .setFeaturesAdditional(
                featuresSponsorAdvertiser,
                featuresForeignAdvertiser
            )
            .build(routePoints);

    $map.data("map", routeMap);

    new SearchInput().setId($("#form-search-map")).setMap(routeMap).build();

    /*
     * Toggle Sidebar
     */
    $("button.close").click(() => {
        $(".sidebar").attr("style", hideStr);
        $("button.close").attr("style", hideStr);
        $("#searchbar").attr("style", showStr);
        $(".routeOverview").empty();
        $(".routeDesc").empty();
        routeMap.clearMap({ route: true, pins: true, routepins: true });
    });
    $(".btn.clear").on("click", (e) => {
        let $input = $(e.currentTarget).prev("input");
        $input.val("");
        $input.focus();
    });
    if ($(".showRoute").length) {
        $(".showRoute").on("click", (e) => {
            $("#routebar").attr("style", showStr);
            if (isMobile.matches) {
                $("#mobileRouteTop").attr("style", showStr);
            }
            routeMap.checkRouteComplete();
            $("#routePincompany").attr("id", "routePindestination");
        });
    }

    if ($(".showPhone").length) {
        $(".showPhone").on("click", (e) => {
            $(".showPhone").remove();
            $(".callPhone").removeClass("dontShow");
        });
    }
});